const dias = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

const local = {
    localize: {
        day: n => dias[n],
        month: n => meses[n]
    },
    formatLong: {
        date: () => 'dd/mm/yyyy'
    }
}

export { local, dias, meses };